<template>
	<Icon v-bind="$props">
		<svg
			width="203px"
			height="15px"
			viewBox="0 0 203 15"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g
				stroke="none"
				stroke-width="1"
				fill="none"
				fill-rule="evenodd"
				class="light"
			>
				<g transform="translate(-913.000000, -770.000000)" fill="currentColor">
					<ellipse cx="1014.5" cy="777.5" rx="101.5" ry="7.5"></ellipse>
				</g>
			</g>
		</svg>
	</Icon>
</template>

<script>
import Icon, { props } from './Icon'
export default {
	name: 'ProntoCloudShadowIcon',
	components: { Icon },
	props,
}
</script>
